import { mesaColorNames } from '@/src/common/theme'
import Svg, { SvgProps, Path } from 'react-native-svg'

export function CircleCheck(props: SvgProps) {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        stroke={props.color ?? mesaColorNames['Acre Turquoise/800 #086762']}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M20 11.269v.736a8 8 0 1 1-4.744-7.312M9 10.333l2.626 2.627a1 1 0 0 0 1.414 0L19 7"
      />
    </Svg>
  )
}
